var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPdtnm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9321 -8250)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(-9321 8250)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10406.14 7972.366)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1093.188 285.687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4770.208,2249.148c1.175,0,2.35.012,3.525,0a3.316,3.316,0,0,1,2.485,1.02q3.471,3.467,6.939,6.937a3.23,3.23,0,0,1-.007,4.7q-3.091,3.095-6.185,6.185a3.231,3.231,0,0,1-4.76.007q-3.478-3.465-6.942-6.945a3.3,3.3,0,0,1-1-2.417c.01-2.388,0-4.778,0-7.166a2.09,2.09,0,0,1,2.294-2.319C4767.781,2249.141,4769,2249.149,4770.208,2249.148Zm.024,2.058c-1.162,0-2.324.009-3.486-.005-.325,0-.439.106-.438.433.01,2.3-.013,4.594.025,6.891a1.691,1.691,0,0,0,.425,1.062c2.28,2.329,4.591,4.629,6.9,6.926a1.174,1.174,0,0,0,1.868-.028q3.085-3.076,6.161-6.161a1.112,1.112,0,0,0,0-1.74q-3.439-3.448-6.884-6.891a1.591,1.591,0,0,0-1.205-.49C4772.476,2251.213,4771.354,2251.206,4770.233,2251.206Z",
    transform: "translate(-4764.269 -2249.144)",
    fill: "#707070",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4814.663,2300.577a1.013,1.013,0,0,1-1.035-1.018,1.047,1.047,0,0,1,1.04-1.027,1.006,1.006,0,0,1,1.014,1A.966.966,0,0,1,4814.663,2300.577Z",
    transform: "translate(-4809.717 -2294.619)",
    fill: "#71aff8",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1102.067 299.629) rotate(-45)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.685,
    height: 1.433,
    rx: 0.716,
    transform: "translate(0)",
    fill: "#71aff8"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPdtnm);
export default __webpack_public_path__ + "static/media/icon-pdtnm.7367f993.svg";
export { ForwardRef as ReactComponent };